module.exports = __webpack_public_path__ + "static/Saskatchewan-aa5a363adcdf344e7739984a449ef7e0.png";